
function IntegrationAppService($resource, $cacheFactory, $http) {

    var baseUrl = '../Api/IntegrationApp';
    var serviceCache = $cacheFactory('IntegrationAppService');

    var res = $resource('../Api/IntegrationAppApi/', {}, {
        get: { method: 'GET', params: { }, isArray: false },
        post: { method: 'POST', params: { }, isArray: false }
    });

    res.resetCache = function () {
        serviceCache.removeAll();
    };

    res.logs = [];
    res.automaticScroll = true;

    res.updateAutomaticScroll = function (state) {
        res.automaticScroll = state;
    };

    res.insertLog = function (log) {
        res.logs.push(log);
    };

    res.cleanLogs = function () {
        res.logs = [];
    };

    //IntegrationMonitorService.postMethod('/QueueIntegrationRunOnApp/' + integrationDirection);

    res.queueImport = function (integrationDirection) {
        integrationDirection = 'LocalToWeb';
        return $http.post(baseUrl + '/QueueIntegrationRunOnApp', { integrationDirection: integrationDirection });
    };

    res.execIntegr = function (integr) {
        var put = $http.put(baseUrl + '/ExecIntegr', integr);
        res.resetCache();
        return put;
    };

    res.getQueue = function () {
        return $http.get(baseUrl + '/GetQueue', {
            cache: false
        });
    };

    res.getIntegrTables = function () {
        return $http.get(baseUrl + '/GetIntegrTables', {
            cache: false
        });
    };

    res.getIntegrTableIDs = function () {
        return $http.get(baseUrl + '/GetIntegrTableIDs', {
            cache: false
        });
    };

    //res.getIntegrSyncs = function () {
    //    return $http.get(baseUrl + '/GetIntegrSyncs', {
    //        cache: false
    //    });
    //};

    res.saveIntegrTable = function (integr) {
        var put = $http.put(baseUrl + '/SaveIntegrTable', integr);
        res.resetCache();
        return put;
    };

    return res;
}

seedWebServices.service('IntegrationAppService', ['$resource', '$cacheFactory', '$http', IntegrationAppService]);

